/* QualifyCvesOptionsComponent.js */


const EventEmitter = require("events").EventEmitter;
const Renderer = require("./QualifyCvesOptionsRenderer");

class QualifyCvesOptionsComponent extends EventEmitter {
    constructor(logger, message) {
        super();
        this._logger = logger;
        this._titleText = message || "Qualify CVE Exposure — Options";
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    get titleText() {
        return this._titleText;
    }
    get logger() {
        return this._logger;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._context = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "QualifyCvesOptionsComponent.shutdown() error");
            }
        );
    }

    /**
     * Resolve the display promise with the collected launch options.
     * @param {Object} values Raw control values gathered by the renderer.
     */
    launch(values) {
        this._context.resolve(values);
    }

    /**
     * Reject the display promise so the launcher treats it as a user cancel.
     * @param {Error} err Error carrying userRejected = true.
     */
    cancel(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /*******************************************/
}
module.exports = QualifyCvesOptionsComponent;
